import React, { useEffect, useState } from "react";
import axiosClient from "../../../config/axios.js";
import { Link } from "react-router-dom";
import OrdersBillingTable from "./ordersBillingTable.js";

function OrdersBilling() {
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("TODAS");
  const [updateFlag, setUpdateFlag] = useState(0);

  const fetchOrderStatuses = async () => {
    try {
      const response = await axiosClient.get(
        "/orderStatuses/allWithOrderCount",
        { params: { sortColumn: "id" } }
      );
      setOrderStatuses(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchOrderStatuses();
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item active">Facturación de ordenes</li>
          </ol>
          <h1 className="page-header mb-0">Facturación de ordenes</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <div className="card border-0">
            <div className="tab-content p-3">
              <div
                key="tab_pane_all"
                className={`tab-pane fade ${
                  currentStatus === "TODAS" ? "active show" : ""
                }`}
                id="tab_all"
              >
                {currentStatus === "TODAS" && (
                  <OrdersBillingTable
                    key={`OrderTable_all_${updateFlag}`}
                    orderStatusCode={null}
                    updateFlag={updateFlag}
                  />
                )}
              </div>

              {orderStatuses.map((orderStatus) => (
                <div
                  key={`tab_pane_${orderStatus.id}`}
                  className={`tab-pane fade ${
                    orderStatus.order_status_code === currentStatus
                      ? "active show"
                      : ""
                  }`}
                  id={`tab_${orderStatus.id}`}
                >
                  {orderStatus.order_status_code === currentStatus && (
                    <OrdersBillingTable
                      key={`OrderTable_${orderStatus.id}`}
                      orderStatusCode={orderStatus.order_status_code}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrdersBilling;
